// Import mutators and orchestrators here to register them
// Note that mutators must come before orchestrators.
import './mutators';
import './orchestrators';

export { refreshSharingTipsAttachmentWell } from './actions/publicActions';

export {
    default as addAttachmentIntoWellBeforeUpload,
} from './actions/addAttachmentIntoWellBeforeUpload';
export { default as initializeAttachments } from './actions/initialization/initializeAttachments';
export {
    default as reinitializeAttachments,
} from './actions/initialization/reinitializeAttachments';
export { default as getAttachmentWellForCompose } from './utils/getAttachmentWellForCompose';
export { default as getAttachmentWellInitialValue } from './utils/getAttachmentWellInitialValue';
export {
    default as getAvailableLocalAttachmentSize,
} from './utils/getAvailableLocalAttachmentSize';
export {
    default as getConversationAttachmentWellInitialValue,
} from './utils/getConversationAttachmentWellInitialValue';
export { default as getImageDimensionsFromFile } from './utils/getImageDimensionsFromFile';
export { default as getMaxClassicAttachmentsSize } from './utils/getMaxClassicAttachmentsSize';
export { default as getAllValidAttachments } from './utils/getAllValidAttachments';
export {
    default as createAttachmentFullViewStateAndStoreBackingModel,
} from 'owa-attachment-full-data/lib/actions/createAttachmentFullViewStateAndStoreBackingModel';
export {
    default as setInlineAttachmentStatus,
} from 'owa-attachment-full-data/lib/actions/setInlineAttachmentStatus';
export {
    default as createAttachmentFullViewState,
} from 'owa-attachment-full-data/lib/utils/createAttachmentFullViewState';
export {
    default as createAttachmentsViaQueueManager,
    deleteAttachmentViaQueueManager,
} from './actions/createAttachmentsViaQueueManager';
export {
    default as createAttachmentFileFromExistingMailboxAttachment,
} from './utils/AttachmentQueueManager/createAttachmentFileFromExistingMailboxAttachment';
export {
    default as mergeToConversationAttachmentWell,
} from './mutators/mergeToConversationAttachmentWell';
export {
    default as sortConversationAttachmentWell,
} from './mutators/sortConversationAttachmentWell';
export {
    default as convertImageViewAttachmentToInlineAttachment,
} from './actions/convertImageViewAttachmentToInlineAttachment';

export {
    getLastCloudyAttachmentsSharingIssueForBlockOnSend,
} from './orchestrators/sharingTips/refreshSharingTipsAttachmentWell';
